import { CloneProjectState } from "@app/projects/clone/CloneProject";
import CreateProject from "@app/projects/create/createProject";
import { CreateProjectWizardState } from "@app/projects/create/interfaces";
import { ProjectOptionsState } from "@app/projects/network-assessment/EditProject";
import Project from "@app/projects/project";

/* eslint-disable sort-keys */
/* These keys are listed in order of where they appear in the edit project UI */
/* This method is specifically for when cloning projects */
export const cloneThingsToResetIfZipProject = (isZipTemplate: boolean): Partial<ProjectOptionsState | CloneProjectState> => {
  return isZipTemplate ? {
    // template step
    selectedInsurances: [],
    useAccuracy: false,
    // member step
    disableMemberBindingTable: true,
    disableMarketProjectionCopy: true,
    disableProspectProjectionCopy: true,
    disableTerminationCopy: true,
    // options step
    // : exclude prospect/market providers
    excludeDeactivatedFacilityImpact: false,
    excludeDeactivatedProviderImpact: false,
    excludeInvalidNppesNpiFacilityImpact: false,
    excludeInvalidNppesNpiProviderImpact: false,
    excludeMedicareOptOutImpact: false,
    excludeMissingNpiFacilityImpact: false,
    excludeMissingNpiProviderImpact: false,
    excludeOIGExclusionImpact: false,
    excludePrecludedImpact: false,
  } : {};
}

/* This method is specifically for when cloning projects */
export const cloneProjectThingsToResetIfZipProject = (isZipTemplate: boolean): Partial<Project> => {
  return isZipTemplate ? {
    // template step
    accuracySpecialtyDefinitionId: null,
    accuracySpecialtyToQdpCodeMapSetId: null,
    accuracyTemplateCollectionId: null,
    accuracyTemplateCorrelationId: "",
    marketSpecialtyCodeMapSetId: null,
    // members step
    memberSetAlias2: "",
    memberSetId2: null,
    membershipRiskMemberSetAlias: "",
    membershipRiskMemberSetId: null,
    // step providers
    marketProviderSetAlias: "",
    marketProviderSetId: null,
    prospectProviderSetAlias: "",
    prospectProviderSetId: null,
    useMarketProvidersForImpact: true, // we won't have market providers, but this is the default
    useMarketProvidersForMarketAnalysis: false,
    useNetworkProvidersForMarketAnalysis: false,
    useProspectProvidersForMarketAnalysis: false,
    // options step
    // : analysis
    excludeInVolumeActions: true,
    includeInEnterpriseComplianceDashboard: false,
    autoArchiveUnarchiveSpecialtyExceptions: false,
    showAccuracyGapAnalysis: false,
    showCMSCredit: false,
    strictTimeAndDistance: true,
    // : display options
    hasZipSummaries: false,
    includeGapAging: false,
    showAttestation: false,
    showAdvancedComparison: false,
    showClosestProviderReport: false,
    showNextClosestNetworkProviders: false,
  } : {};
}

// values pasted from initial state in constructor
/* eslint-disable sort-keys */
/* These are in order of appearance in the wizard */
/* This method is specifically for when creating projects */
export const createThingsToResetIfZipProject = (isZipTemplate: boolean): Partial<CreateProjectWizardState> => {
  return isZipTemplate ? {
    // template step
    selectedInsurances: [],
    useAccuracy: false,
    // member step
    disableMemberBindingTable: true,
  } : {};
}

/* This method is specifically for when creating projects */
export const createProjectThingsToResetIfZipProject = (isZipTemplate: boolean): Partial<CreateProject> => {
  return isZipTemplate ? {
    // template step
    accuracyAndAdequacy: false,
    accuracySpecialtyDefinitionDesc: null,
    accuracySpecialtyDefinitionId: null,
    accuracySpecialtyToQdpCodeMapSetDescription: null,
    accuracySpecialtyToQdpCodeMapSetId: null,
    accuracyTemplateCollectionDescription: "",
    accuracyTemplateCollectionId: null,
    accuracyTemplateCorrelationId: "",
    marketSpecialtyCodeMapSetId: null,
    // members step
    memberPopDescription2: "",
    memberSetAlias2: "",
    memberSetId2: null,
    membershipRiskMemberSetAlias: "",
    membershipRiskMemberSetId: null,
    // step providers
    marketProviderSetAlias: "",
    marketProviderDescription: "",
    marketProviderSetId: null,
    prospectProviderSetAlias: "",
    prospectProviderDescription: "",
    prospectProviderSetId: null,
    useMarketProvidersForImpact: true, // we won't have market providers, but this is the default
    useMarketProvidersForMarketAnalysis: false,
    useNetworkProvidersForMarketAnalysis: false,
    useProspectProvidersForMarketAnalysis: false,
    // options step
    // : analysis
    excludeInVolumeActions: true,
    includeInEnterpriseComplianceDashboard: false,
    autoArchiveUnarchiveSpecialtyExceptions: false,
    showAccuracyGapAnalysis: false,
    showCMSCredit: false,
    strictTimeAndDistance: true,
    // : display options
    hasZipSummaries: false,
    includeGapAging: false,
    showAttestation: false,
    showAdvancedComparison: false,
    showClosestProviderReport: false,
    showNextClosestNetworkProviders: false,
    showPatternOfCareProviders: false,
    showPciDashboard: false,
    // : exclude prospect/market providers
    excludeDeactivatedFacilitiesImpact: false,
    excludeDeactivatedProvidersImpact: false,
    excludeInvalidNppesNpiFacilitiesImpact: false,
    excludeInvalidNppesNpiProvidersImpact: false,
    excludeMedicareOptOutProvidersImpact: false,
    excludeMissingNpiFacilitiesImpact: false,
    excludeMissingNpiProvidersImpact: false,
    excludeOIGExcludedProvidersImpact: false,
    excludePrecludedProvidersImpact: false,
    networkSpecialtyCodeMapSetId: null
  } : {};
}
/* eslint-enable sort-keys */
